var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPointPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -0.5 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-pin-map",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "983") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 0.000000)",
    fill: "#434343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.953,8.979 L0.025,8.979 L0.025,7.668 L1,6.991 L1,4.926 L0.025,4.122 L0.025,2.021 L5.953,2.021 L5.953,4.249 L4.979,4.926 L4.979,6.991 L5.954,7.625 L5.953,8.979 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.986,7.993 L2.038,7.993 L2.038,10.607 L3.027,15.979 L3.986,10.607 L3.986,7.993 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 5.959,
    height: 0.942,
    className: "si-glyph-fill"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointPreview);
export default __webpack_public_path__ + "static/media/map-point-preview.f0bdccc5aeefd5e0b2a9394723bb9b5e.svg";
export { ForwardRef as ReactComponent };